require('./transactionRepetition.scss');

const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const moment = require('moment');
const classNames = require('classnames');
// @ commons
const constants = require('constants/index');
const { DATE_PICKER_CUSTOM_PLACEHOLDER, DATE_PICKER_CUSTOM_LOCALE, DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');
const { formatText, FormattedText } = require('core/i18n').i18n;

// @ components
const OKSelect = require('components/commons/OKSelect/OKSelect');
const DatePickerCustom = require('components/datePickerCustom/datePickerCustom');
const { InputSafe } = require('commonsComponents/inputSafe');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');

class TransactionRepetition extends React.Component {

    constructor(props) {
        super(props);
        this.handleRangeChange = this.handleRangeChange.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.handleCountChange = this.handleCountChange.bind(this);
        this.handleTreatmentNonWorkableDay = this.handleTreatmentNonWorkableDay.bind(this);
        this.setDateChange = this.setDateChange.bind(this);
    }

    setDateChange(date) {
        this.props.onDateChange(date);
    }

    /*
        Estimate the end date of scheduled transfers depending on selected periodicity range and amount of transfers
        to be performed.
     */
    estimateEndDate(range, currentDate, count = 0) {
        let nextDate = moment(currentDate).locale(DATE_PICKER_CUSTOM_LOCALE);
        let value = count;
        switch (range) {
            case constants.PERIODICITY_WEEKLY:
                return nextDate.add(value.toString(), 'weeks');
            case constants.PERIODICITY_MONTHLY:
                return nextDate.add(value.toString(), 'months');
            case constants.PERIODICITY_QUARTERLY:
                value = value * 3;
                return nextDate.add(value.toString(), 'months');
            case constants.PERIODICITY_BIANNUAL:
                value = value * 6;
                return nextDate.add(value.toString(), 'months');
        }
    }

    /*
        Estimate how many scheduled transfers will take place between original transfer date and end date,
        depending on selected periodicity range.
     */
    estimateRepetitions(range, currentDate, futureDate) {
        switch (range) {
            case constants.PERIODICITY_WEEKLY:
                return futureDate.diff(currentDate, 'weeks');
            case constants.PERIODICITY_MONTHLY:
                return futureDate.diff(currentDate, 'months');
            case constants.PERIODICITY_QUARTERLY:
                return Math.floor(futureDate.diff(currentDate, 'months') / 3);
            case constants.PERIODICITY_BIANNUAL:
                return Math.floor(futureDate.diff(currentDate, 'months') / 6);
        }
    }

    handleCountChange(evt) {
        const { periodicityRange, transferDate } = this.props;

        let count = parseInt(evt.target.value.replace(/[^\d]/g, '')); /* remove non numbers*/
        const date = this.estimateEndDate(periodicityRange, transferDate, count);
        count = count >= 0 ? count : '';
        this.props.onCountChange(count, date);
    }

    handleRangeChange(selectedElem) {
        this.props.onRangeChange(selectedElem.value);
    }

    handleTreatmentNonWorkableDay(value) {
        this.props.onTreatmentNonWorkableDay(value);
    }

    handleTypeChange(selectedElem) {
        this.props.onTypeChange(selectedElem.value);
    }

    render() {
        const {
            isEcardOrOYFlow,
            periodicityCount = '',
            periodicityCountIsInvalid,
            periodicityDate,
            periodicityMinDate,
            periodicityRange,
            periodicityTreatmentNonWorkableDay,
            periodicityType,
            transferDate
        } = this.props;
        let periodicityOptions = [
            {
                value: constants.PERIODICITY_MONTHLY,
                label: formatText('periodicity-monthly')
            },
            {
                value: constants.PERIODICITY_QUARTERLY,
                label: formatText('periodicity-quarterly')
            },
            {
                value: constants.PERIODICITY_BIANNUAL,
                label: formatText('periodicity-biannual')
            }
        ];
        
        const periodicityEndOptions = [
            {
                value: constants.PERIODICITY_CONSTANTLY,
                label: formatText('periodicity-constantly')
            },
            {
                value: constants.PERIODICITY_DATE,
                label: formatText('periodicity-date')
            },
            {
                value: constants.PERIODICITY_COUNT,
                label: formatText('periodicity-count')
            }
        ];
        
        const cardChargePeriodicityEndOptions = [
            {
                value: constants.PERIODICITY_CONSTANTLY,
                label: formatText('periodicity-constantly')
            },
            {
                value: constants.PERIODICITY_DATE,
                label: formatText('periodicity-date')
            },
            {
                value: constants.PERIODICITY_COUNT,
                label: formatText('cardChargePeriodicity-count')
            }
        ];
        const clearable = false;
        const searchable = false;
        const labelRange = formatText('periodicity-range');
        const labelType = formatText('periodicity-type');
        const labelEmittedDateBefore = formatText('transferSummary-step1EmittedDateBefore');
        const labelEmittedDateAfter = formatText('transferSummary-step1EmittedDateAfter');

        let extraField;
        let extraFieldMsg;
        let radioButtonGroupFields;

        if(!isEcardOrOYFlow) {
            radioButtonGroupFields = (<div className="transfer-first-step__form-section">
                <label id="lbl_TransferStep1_EmittedDateTreatment" className="transfer-first-step__field-label">
                    <FormattedText value="transferSummary-step1EmittedDateTreatment" />
                </label>
                <RadioButtonGroup
                    name="emittedDateFlag"
                    idPrefix="emittedDateFlagRadio"
                    selectedValue={periodicityTreatmentNonWorkableDay}
                    onChange={this.handleTreatmentNonWorkableDay}
                >
                    <RadioButton label={labelEmittedDateBefore} value={constants.TRANSFER_EMITTED_DAY_BEFORE} />
                    <RadioButton label={labelEmittedDateAfter} value={constants.TRANSFER_EMITTED_DAY_AFTER} />
                </RadioButtonGroup>
            </div>);
        } else {
            if(periodicityOptions[0].value !== constants.PERIODICITY_WEEKLY){
                periodicityOptions.splice(0, 0, {
                    value: constants.PERIODICITY_WEEKLY,
                    label: formatText('periodicity-weekly')
                });
            }
        }

        if (periodicityType === constants.PERIODICITY_DATE) {
            const labelDate = formatText('periodicity-lastPaymentDate');
            const repetitions = Math.max(this.estimateRepetitions(periodicityRange, transferDate, periodicityDate), 1); //Catch the case where estimated repetitions returns zero.
            const msg = (isEcardOrOYFlow) ? `${repetitions} ${formatText('cardChargePeriodicity-repetitions')}` : `${formatText('periodicity-repetitions')} ${repetitions}`;

            extraField = (
                <div className="transaction-repetition__extra-field">
                    <DatePickerCustom
                        id="transactionRepetition_date"
                        label={labelDate}
                        callback={this.setDateChange}
                        selectedDate={periodicityDate}
                        maxDate={moment(transferDate).startOf('day').add('100', 'years')}
                        minDate={periodicityMinDate}
                        placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                        locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                        dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                    />
                </div>
            );

            extraFieldMsg = (
                <div className="transaction-repetition__extra-field-msg">
                    {msg}
                </div>
            );

        } else if (periodicityType === constants.PERIODICITY_COUNT) {
            const labelCount = `${formatText('periodicity-number')} *`;
            const estimatedDate = this.estimateEndDate(periodicityRange, transferDate, periodicityCount).format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT));
            let msg;

            const extraFieldMsgClassName = classNames('transaction-repetition__extra-field-msg', {
                'transaction-repetition__extra-field-msg--error': periodicityCountIsInvalid
            });

            if (!periodicityCountIsInvalid) {
                const totalMsg = (isEcardOrOYFlow) ? 'cardChargePeriodicity-total' : 'periodicity-total';
                const total = formatText(totalMsg, [periodicityCount + 1]);
                msg = `${total} ${estimatedDate}`;
            } else {
                msg = formatText('periodicity-countIsInvalid');
            }

            extraFieldMsg = (
                <div className={extraFieldMsgClassName}>
                    {msg}
                </div>
            );

            extraField = (
                <div className="transaction-repetition__extra-field">
                    <div className="transaction-repetition__extra-field-input transaction-repetition__card-charge-input">
                        <InputSafe
                            id="inp_TransactionRepetition_TransfersCount"
                            label={labelCount}
                            type="text"
                            value={periodicityCount}
                            maxLength="5"
                            errorState={periodicityCountIsInvalid}
                            onChange={this.handleCountChange}
                        />
                    </div>
                </div>
            )
        }
        const periodicityEndOptionList = (isEcardOrOYFlow) ? cardChargePeriodicityEndOptions : periodicityEndOptions;

        return (
            <div className="transaction-repetition transaction-repetition-card-charge ">
                <div className="transfer-first-step__form-section">
                    <div className="transaction-repetition__select">
                        <OKSelect
                            label={labelRange}
                            name="form-field-periodicity-range"
                            onChange={this.handleRangeChange}
                            options={periodicityOptions}
                            value={periodicityRange}
                            searchable={searchable}
                            clearable={clearable}
                        />
                    </div>
                </div>
                <div className="transfer-first-step__form-section">
                    <div className="transaction-repetition__select">
                        <OKSelect
                            label={labelType}
                            name="form-field-periodicity-type"
                            onChange={this.handleTypeChange}
                            options={periodicityEndOptionList}
                            value={periodicityType}
                            searchable={searchable}
                            clearable={clearable}
                        />
                    </div>
                    {extraField}
                    {extraFieldMsg}
                </div>
                {radioButtonGroupFields}
            </div>
        );
    }
}

TransactionRepetition.propTypes = {
    onRangeChange: PropTypes.func,
    onTypeChange: PropTypes.func,
    onCountChange: PropTypes.func,
    onDateChange: PropTypes.func,
    onTreatmentNonWorkableDay: PropTypes.func,
    periodicityCountIsInvalid: PropTypes.bool,
    periodicityRange: PropTypes.string.isRequired,
    periodicityType: PropTypes.string.isRequired,
    periodicityDate: PropTypes.object.isRequired,
    periodicityMinDate: PropTypes.object.isRequired,
    periodicityCount: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number]),
    periodicityTreatmentNonWorkableDay: PropTypes.string,
    transferDate: PropTypes.object,
    isEcardOrOYFlow: PropTypes.bool,
};

module.exports = TransactionRepetition;
